__turbopack_context__.v({
  "container": "MembersInviteTagInput-module-scss-module__XsWUIW__container",
  "errorMessage": "MembersInviteTagInput-module-scss-module__XsWUIW__errorMessage",
  "field": "MembersInviteTagInput-module-scss-module__XsWUIW__field",
  "input": "MembersInviteTagInput-module-scss-module__XsWUIW__input",
  "inputArea": "MembersInviteTagInput-module-scss-module__XsWUIW__inputArea",
});
